/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
    this.bindCloseHandlers();
    this.restoreCrossSells();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  /**
   * Apps (e.g. Discounty) can replace the whole drawer element while it is open.
   * The new element then never ran open(), so it has no click handler and the
   * close button stops working. Bind the handler as soon as the element connects.
   */
  bindCloseHandlers() {
    try {
      this.clickHandler = this.clickHandler || this.handleClick.bind(this);
      this.addEventListener('click', this.clickHandler);
      if (this.overlay) this.overlay.addEventListener('click', this.clickHandler);
    } catch (e) { /* ignore */ }
  }

  /**
   * If an app replaced the drawer and the 'More to love' block came back empty,
   * fetch it again from a normal page render and put it back.
   */
  restoreCrossSells() {
    setTimeout(async () => {
      try {
        const box = this.querySelector('[data-merge="cross-sells"]');
        if (!box || box.querySelector('cc-cart-cross-sell') || box.children.length) return;
        const cart = await fetch('/cart.js').then((r) => r.json());
        if (!cart.item_count) return;
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const html = await fetch(root + 'nava-cart-fix').then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const src = doc.querySelector('cart-drawer [data-merge="cross-sells"]');
        if (!src || !src.querySelector('cc-cart-cross-sell')) return;
        const target = this.querySelector('[data-merge="cross-sells"]');
        if (!target || target.children.length) return;
        target.innerHTML = src.innerHTML;
        if (src.dataset.mergeCache) target.dataset.mergeCache = src.dataset.mergeCache;
        target.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init && el.init());
        if (window.theme && theme.manuallyLoadImages) theme.manuallyLoadImages(target);
      } catch (e) { /* ignore */ }
    }, 400);
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
